// hooks/useTracking.js (versão com tracking de mudanças de rota)
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/tracking';

export const useTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      trackPageView();
    }
  }, [location.pathname]); // Roda toda vez que o path mudar
};